import { environment } from '@mg-platform/core/core-util'

export const CONFIG_API_URL = {
  adminConfig: `${environment.apiUrl}/admin/config`
}
